export const normalizeRegion = (region) => {
  let str = region.toLowerCase();
  let i = str.indexOf(' обл');
  if (i > -1) return toUpper(str.substring(0, i));
};

export const normalizeRegionFullname = (region) => {
  let str = region.toLowerCase();
  let i = str.indexOf(' обл');
  if (i > -1) return toUpper(str.substring(0, i)) + ' область';
};

export const normalizeDistrict = (district) => {
  if (district === 'ЯКИМІВСЬКИЙ Р-Н М.ЗАПОРІЖЖЯ') return 'Якимівський район м. Запоріжжя';
  if (district === 'М. ГОРІШНІ ПЛАВНІ ПОЛТАВСЬКА ОБЛ.') return 'м. Горішні Плавні';

  let str = district.toLowerCase();
  let i = str.indexOf(' р-н');
  if (i !== -1) return toUpper(str.substring(0, i));

  i = str.indexOf(' район');
  if (i !== -1) return toUpper(str.substring(0, i));

  // corrected
  i = str.indexOf('м.');
  if (i !== -1) return 'м. ' + toUpper(str.substring(2, str.indexOf(' ')));
};

export const findDivider = (name) => {
  if (name.includes('-')) return '-';
  else if (name.includes(' | ')) return ' | ';
};

// function corrected
export const capitalizeWord = (word) => {
  // return word[0].toUpperCase() + word.substr(1);
  if (word) return word[0].toUpperCase() + word.substr(1);
  return '';
};

export const toUpper = (str) => {
  let devider = findDivider(str);
  return str
    .toLowerCase()
    .split(devider)
    .map((word) => capitalizeWord(word))
    .join(devider);
};
